var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3278_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6.10352e-05C12.8355 6.10352e-05 9.74207 0.938445 7.11088 2.69655C4.4797 4.45465 2.42894 6.95351 1.21793 9.87713C0.00693256 12.8007 -0.309921 16.0178 0.307443 19.1215C0.924806 22.2252 2.44866 25.0761 4.6863 27.3138C6.92394 29.5514 9.77487 31.0753 12.8786 31.6926C15.9823 32.31 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5204 29.3035 24.8892C31.0616 22.258 32 19.1646 32 16.0001C32 11.7566 30.3143 7.68693 27.3137 4.68635C24.3131 1.68577 20.2435 6.10352e-05 16 6.10352e-05ZM18.8805 17.4927H16.4452V24.275H12.8445V17.4927H11.1293V14.4616H12.8445V12.4976C12.8445 11.0901 13.4992 8.88386 16.4845 8.88386H19.162V11.8298H17.198C17.09 11.822 16.9815 11.8384 16.8806 11.8778C16.7797 11.9173 16.6889 11.9788 16.6149 12.0579C16.5408 12.137 16.4854 12.2316 16.4526 12.3349C16.4199 12.4381 16.4106 12.5474 16.4255 12.6547V14.442H19.1751L18.8805 17.4927Z",
    fill: "#40484C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3278_1992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebook-dark.01831873f4d69c02e60dff0afe318d65.svg";
export { ForwardRef as ReactComponent };